<template>
  <div class="addMain wraper">
    <template>
      <el-backtop target=".wraper"></el-backtop>
    </template>
    <div v-if="$route.meta.routeList.length>1" class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1 v-if="flag != 'edit'">创建设备协议</h1>
        <h1 v-if="flag == 'edit'">更新设备协议</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="flag != 'edit'">创建设备协议，以保证设备的连接。</h3>
          <h3 v-if="flag == 'edit'">更新设备协议信息。</h3>
        </div>
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="设备协议名称" prop="name"><br />
            <div class="subheading">输入设备名称，方便辨别设备。最大长度为50个字符</div>
            <el-input v-model="addForm.name" placeholder="请输入" maxlength="50"></el-input>
          </el-form-item>
          <!-- <el-form-item label="协议编号" prop="code"><br />
            <div class="subheading">
              输入设备协议编号。
            </div>
            <el-input v-model="addForm.code" placeholder="请输入"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="设备离线时间间隔（秒）" prop="offlineInterval"
            ><br />
            <div class="subheading">
              输入设备离线时间间隔。
            </div>
            <el-input v-model="addForm.offlineInterval" placeholder="请输入"></el-input>
          </el-form-item> -->
          <el-form-item label="解析方式" prop="protocolType"><br />
            <div class="subheading">
              请选择解析方式。<br>
              <b>模板解析</b>：按照协议中上行包、下行包配置顺序解析<br>
              <b>脚本解析</b>：按照脚本内容来解析
            </div>
            <el-select v-model="addForm.protocolType" filterable placeholder="未选择" :disabled="flag == 'edit'">
              <el-option v-for="item in protocolType" :key="item.id" :label="item.content" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="协议脚本文件" prop="analysisScriptAttachmentId" v-if="addForm.protocolType == 1"><br />
            <div class="subheading">
              请<el-upload :disabled="analysisScript.length>0" style="display: inline" :action="uploadAnalysis"
                :show-file-list="false" class="upload-demo" :limit="1" :data="tokenData" accept="groovy"
                :file-list="analysisScriptAttachmentIdFileList" :before-upload="beforeAvatarUpload"
                :on-success="analysisScriptUploadSuccess" :on-remove="analysisScriptUploadRemove"
                :with-credentials='true' :headers="myHeaders">
                <el-tooltip effect="dark" content="上传脚本时需删除原脚本" placement="top">
                  <el-button type="text">上传</el-button>
                </el-tooltip>
              </el-upload>或<el-button type="text" @click="editScript()">编写</el-button>协议脚本文件，如需帮助请阅读
              <el-button type="text" @click="help">帮助文档</el-button>，文件大小不超过4MB。
            </div>
            <div
              style="width:370px;height:180px;border:dotted 1px #cccccc;border-radius: 5px;margin-top:10px;padding:3px;overflow: hidden;">
              <div style="text-align: right;" v-if="analysisScript">
                <i class="el-icon-close" style="color:#DD5145;" title="清空脚本" @click="cleanScript"></i>&nbsp;
              </div>
              <pre
                style="color:#747DB0;width:100%;height:100%;text-overflow:ellipsis;overflow: hidden;">{{showScript}}</pre>
            </div>
          </el-form-item>
          <el-form-item label="协议说明文档附件" prop="attachmentId"><br />
            <div class="subheading">
              请上传协议的说明文档，文件大小不超过20MB。
            </div>
            <el-upload :action="upload" show-file-list :data="tokenData" class="upload-demo" :limit="1"
              :file-list="attachmentIdFileList" :on-success="attachmentIdUploadSuccess" :on-error="attachmentUploadFail"
              accept="application/pdf,text/plain,text/markdown,application/msword,application/x-zip-compressed,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              :before-upload="beforeDocUpload" :on-remove="attachmentIdUploadRemove" :with-credentials='true'
              :headers="myHeaders" drag>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注" prop="remarks"><br />
            <div class="subheading">请简要填写备注。最大长度为255个字符</div>
            <el-input type="textarea" :rows="3" v-model="addForm.remarks" placeholder="请输入" maxlength="255"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit('addForm')">创建设备协议</el-button>
            <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit('addForm')">更新设备协议</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-dialog title="脚本编写" :visible.sync="scriptDialog" top="10px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" width="90%">
      <div style="margin-top: -30px">
        <script-debug-component :initVal="scriptInitVal" :script="scriptContent" @changeScript="changeScript">
        </script-debug-component>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scriptDialog = false">关 闭</el-button>
        <el-button type="primary" @click="saveScript">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import scriptDebugComponent from '../../components/scriptDebugComponent'
  export default {
    components: {
      scriptDebugComponent
    },
    data() {
      return {
        user_name: this.$cookies.get("user_name"),
        myHeaders: {
          Authentication: this.$cookies.get('token')
        },
        routeList: this.$route.meta.routeList,
        flag: this.$route.query.flag,
        rules: {
          name: [{
            required: true,
            message: "请输入设备名称",
            trigger: "blur"
          }],
        },
        addForm: {
          model: "",
          devProtocolId: "",
          type: 2,
          protocolType: 2
        },
        attachmentIdFileList: [],
        analysisScriptAttachmentIdFileList: [],
        upload: API.uploadFile(), //上传地址
        uploadAnalysis: API.uploadAnalysis(), //上传脚本地址
        analysisScriptAttachmentId: "", //装着协议脚本文本的id(不可多个)
        analysisScript: "",
        analysisScriptMd5: "",
        attachmentId: "", //装着协议说明文档附件的id(不可多个)
        attachmentName: "",
        protocolType: [
          //设备协议类型下拉数据
          {
            id: 1,
            content: "脚本解析"
          },
          {
            id: 2,
            content: "模板解析"
          }
        ],
        scriptDialog: false, //脚本编写弹窗
        scriptInitVal: '', //脚本初始化值
        scriptContent: '', //脚本内容
        showScript: "请上传或编写脚本文件", //脚本内容快照展示
        developDocumentLink: ''
      };
    },
    computed: {
      tokenData: function () {
        return {
          access_token: this.$cookies.get('access_token')
        }
      }
    },
    watch: {
      analysisScript(newVal, oldVal) {
        if (newVal == '') {
          return false
        }
        var reg = new RegExp('/r/n', "g")
        var text = newVal.replace(reg, '\n');
        this.showScript = text;
      }
    },
    created() {},
    methods: {

      //跳转到帮助文档
      help() {
        this.getDevelopDocumentLink()
        setTimeout(() => {
          window.open(this.developDocumentLink);
        }, 200);
      },

      //获取帮助文档地址
      getDevelopDocumentLink() {
        if (sessionStorage.getItem("developDocumentLink")) {
          this.developDocumentLink = sessionStorage.getItem("developDocumentLink")
        } else {
          API.getDictionaryListByCode({
            typeCode: "developDocumentLink"
          }).then(res => {
            if (res.code === 1) {
              var dictionaryList = res.data.dictionaryList
              if (dictionaryList.length > 0) {
                this.developDocumentLink = dictionaryList[0].content;
                sessionStorage.setItem("developDocumentLink", this.developDocumentLink)
              }
            }
          })
        }
      },

      //当页面为编辑状态flag==edit时要获取到当前编辑的信息
      getMage() {
        if (this.flag == "edit") {
          let id = this.$route.query.id;
          API.platformDevProtocolUpdateDetails(id).then(res => {
            if (res.code == 1) {
              this.addForm = res.data;
              if (res.data.protocolType == 1) {
                let nalysisScriptAttachmentIdObj = {
                  name: res.data.analysisScriptMd5,
                  id: res.data.analysisScriptAttachmentId
                };
                this.analysisScriptAttachmentIdFileList.push(
                  nalysisScriptAttachmentIdObj
                );
                this.analysisScriptAttachmentId =
                  res.data.analysisScriptAttachmentId;
                this.analysisScript = res.data.analysisScript
              }
              if (res.data.attachmentId != null && res.data.attachmentId != "") {
                let attachmentIdObj = {
                  name: res.data.attachmentName,
                  id: res.data.attachmentId
                };
                this.attachmentIdFileList.push(attachmentIdObj);
                this.attachmentId = res.data.attachmentId;
              }
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      },
      //上传协议脚本文件成功时的钩子
      analysisScriptUploadSuccess(res, file, fileList) {
        if (res.code == 1) {
          this.analysisScriptAttachmentId = res.data.id;
          this.analysisScript = res.data.content;
          this.analysisScriptMd5 = res.data.name;
        } else {
          this.$message.error(res.msg);
        }
      },

      beforeDocUpload(file) {
        let index = file.name.lastIndexOf("."); //最后一个.号
        let type = file.name.substring(index + 1, file.name.length); //获取到文件的类型，
        const isLt20M = file.size / 1024 / 1024 <= 20; //图片大小不超过20MB
        if (!isLt20M) {
          this.$message.error("上传文件大小不能超过20M!");
          return false;
        }
        if (type == "zip" || type == "pdf" ||
          type == "doc" || type == "png" ||
          type == "jpg" || type == "md" ||
          type == "txt" || type == "docx") {
          return true;
        } else {
          this.$message.error(
            "上传的文件类型不正确,必须为zip,pdf,doc,docx,png,jpg,md,txt类型,请重新上传"
          );
          return false;
        }
      },

      beforeAvatarUpload(file) {
        let index = file.name.lastIndexOf("."); //最后一个.号
        let type = file.name.substring(index + 1, file.name.length); //获取到文件的类型，
        const isLt4M = file.size / 1024 / 1024 <= 4; //图片大小不超过4MB
        if (!isLt4M) {
          this.$message.error("上传文件大小不能超过 4M!");
          return false;
        }
        if (type == "groovy") {
          return true;
        } else {
          this.$message.error(
            "上传的文件类型不正确（必须为groovy文件类型），请重新上传"
          );
          this.analysisScriptAttachmentIdFileList = []
          return false;
        }
      },
      //移除协议脚本文件
      analysisScriptUploadRemove(file, fileList) {
        if (file.response || file.id) {
          this.analysisScriptAttachmentId = "";
        }
      },
      //上传协议说明文档附件
      attachmentIdUploadSuccess(res, file, fileList) {
        if (res.code == 1) {
          this.attachmentId = res.data.id;
        } else if (res.code == 0) {
          this.$message.error(res.msg)
          this.attachmentIdFileList = []
        }
      },

      attachmentUploadFail() {
        this.$message.error('上传失败')
      },

      //移除协议说明文档附件
      attachmentIdUploadRemove(file, fileList) {
        if (file.response) {
          this.attachmentId = "";
        }
      },
      //实时获取编写的脚本内容
      changeScript(scriptText) {
        this.scriptContent = scriptText
      },
      //编写脚本按钮
      editScript() {
        this.scriptDialog = true
        this.scriptInitVal = this.analysisScript
      },
      saveScript() { //保存编写的脚本弹窗
        this.analysisScript = this.scriptContent;
        this.scriptDialog = false;
        this.analysisScriptAttachmentId = ''
        this.analysisScriptAttachmentIdFileList = []
      },
      cleanScript() {
        this.scriptContent = ''
        this.analysisScript = ''
        this.showScript = '请上传或编写脚本文件'
        this.analysisScriptAttachmentId = ''
        this.analysisScriptAttachmentIdFileList = []
      },
      //创建设备协议
      onSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (_this.addForm.protocolType == 1) {
              _this.addForm.analysisScriptAttachmentId =
                _this.analysisScriptAttachmentId;
              _this.addForm.analysisScript = _this.analysisScript;
              _this.addForm.analysisScriptMd5 = _this.analysisScriptMd5;
            }
            if (_this.attachmentId != "") {
              _this.addForm.attachmentId = _this.attachmentId;
              _this.addForm.attachmentName = _this.attachmentName;
            }
            this.addForm.commuType = sessionStorage.getItem('commuType');
            if (this.user_name == 'suadmin') {
              _API.addplatformDevProtocolCommon(_this.addForm).then(res => {
                if (res.code == 1) {
                  _this.$message({
                    message: "创建设备协议成功",
                    type: "success"
                  });
                  var openNoviceGuide = sessionStorage.getItem("openNoviceGuide") ? sessionStorage.getItem(
                    "openNoviceGuide") : "false";
                  var noviceGuideStep = sessionStorage.getItem("noviceGuideStep") ? sessionStorage.getItem(
                    "noviceGuideStep") : '0';
                  if (openNoviceGuide == "true" && noviceGuideStep == '2') {
                    this.changeNoviceGuideStep('noviceGuideStep', 3);
                    //页面跳转
                    this.$router.push({
                      path: "/equipment/equipmentAdd",
                    });
                  } else {
                    //跳转到配置物模型页面
                    _this.$router.push({
                      path: "/equipment/uplinkPackage",
                      query: {
                        id: res.data,
                        protocolType: this.addForm.protocolType
                      }
                    });
                  }
                } else {
                  _this.$message({
                    message: res.msg,
                    type: "error"
                  });
                }
              });
              return;
            }
            _API.addplatformDevProtocolPrivate(_this.addForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "创建设备协议成功",
                  type: "success"
                });
                var openNoviceGuide = sessionStorage.getItem("openNoviceGuide") ? sessionStorage.getItem(
                  "openNoviceGuide") : "false";
                var noviceGuideStep = sessionStorage.getItem("noviceGuideStep") ? sessionStorage.getItem(
                  "noviceGuideStep") : '0';
                if (openNoviceGuide == "true" && noviceGuideStep == '2') {
                  this.changeNoviceGuideStep('noviceGuideStep', 3);
                  //页面跳转
                  this.$router.push({
                    path: "/equipment/equipmentAdd",
                  });
                } else {
                  //跳转到配置物模型页面
                  _this.$router.push({
                    path: "/equipment/uplinkPackage",
                    query: {
                      id: res.data,
                      protocolType: this.addForm.protocolType
                    }
                  });
                }
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      },
      //更新设备协议
      editOnSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            //********************先初始化上传附件的数据保证下面判断的数据正确赋值************************* */
            _this.addForm.analysisScriptAttachmentId = "";
            _this.addForm.analysisScript = "";
            _this.addForm.analysisScriptMd5 = "";
            _this.addForm.attachmentId = "";
            _this.addForm.attachmentName = "";
            //********************先初始化上传附件的数据保证下面判断的数据正确赋值************************* */
            if (_this.addForm.protocolType == 1) {
              _this.addForm.analysisScriptAttachmentId =
                _this.analysisScriptAttachmentId;
              _this.addForm.analysisScript = _this.analysisScript;
              _this.addForm.analysisScriptMd5 = _this.analysisScriptMd5;
            }
            if (_this.attachmentId != "") {
              _this.addForm.attachmentId = _this.attachmentId;
              _this.addForm.attachmentName = _this.attachmentName;
            }
            if (this.user_name == 'suadmin') {
              _API.editCommonPlatformDevProtocol(this.$route.query.id, _this.addForm)
                .then(res => {
                  if (res.code == 1) {
                    _this.$message({
                      message: "更新设备协议成功",
                      type: "success"
                    });
                    _this.$router.push({
                      path: "/equipment/equipmentProtocolLibrary"
                    });
                  } else {
                    _this.$message({
                      message: res.msg,
                      type: "error"
                    });
                  }
                });
              return;
            }
            _API.editPrivatePlatformDevProtocol(this.$route.query.id, _this.addForm)
              .then(res => {
                if (res.code == 1) {
                  _this.$message({
                    message: "更新设备协议成功",
                    type: "success"
                  });
                  _this.$router.push({
                    path: "/equipment/equipmentProtocolLibrary"
                  });
                } else {
                  _this.$message({
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      },
    },
    mounted() {
      this.getMage();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/equimentProtocolAdd.vue